<template>
  <div>
    
    <div v-if="!rows.length">
      <div class="webkit-animation webkit-100-440"></div>
    </div>


    <div class="carousel-header">
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">

        <ol class="carousel-indicators">
          <li v-for="(row, index) in rows" 
              :key="index"
              data-target="#carouselExampleIndicators" 
              :data-slide-to="index" 
              :class="(index == 0) ? 'active' : ''">
          </li>
        </ol>

        <div class="carousel-inner">
          <div v-for="(row, index) in rows" 
                :key="index" 
                class="carousel-item"
                :class="(index == 0) ? 'active' : ''"
                :data-interval="row.duration + '000'">
            <div class="head-sec sec-top">
              <img class="slider-view-img" v-if="row.file" :src="row.file">
              <!-- <div class="bg-title-slider" v-html="row.title"></div> -->
            </div>
          </div>
        </div>

        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>

      </div>
    </div>
    
  </div>
</template>

<style scoped>
.carousel-control-next,
.carousel-control-prev {
  display: none;
}
.slider-view-img {
  position: relative;
  z-index: 10;
}
.head-sec {
  position: relative;
  /* background: none */
}
.bg-title-slider {
  font-weight: bold;
  z-index: 8;
  line-height: 1;
  text-align: center;
  font-size: 14vw;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
}

@media (max-width: 575.98px) {  }
@media (max-width: 767.98px) { 
  
 }

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {  }

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {  }

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {  }

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 
 
}
</style>


<script>
import axios from "axios";
export default {
  name: "Slider",
  components: {},
  data() {
    return {
      pgLoading: true,
      rows: [],
    };
  },
  computed: {},
  mounted() {},
  created() {
      //
    this.fetchSlider();
  },
  methods: {
      
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          console.log(res.data.rows);
        })
        .catch(() => {});
    },


  },
};
</script>
